import React, {Component} from 'react'

const withSlider = WrappedComponent => {
  return class extends Component {
    static get displayName() {
      const name = WrappedComponent.displayName ||
        WrappedComponent.name || 'Component';
      return `WithSlider(${name})`;
    }

    state = {
      sliderData: [],
      index: 0,
      images: []
    };

    componentDidMount() {
      const {sliderData} = this.props;

      this.updateComponent(sliderData)
    }

    componentDidUpdate(prevProps) {
      const {sliderData} = this.props;

      if (sliderData !== prevProps.sliderData) {
        this.updateComponent(sliderData)
      }
    }

    updateComponent(sliderData) {
      if (sliderData) {
        const images = sliderData instanceof Array ?
          sliderData.map(item => item.images[0]) :
          sliderData.images;

        this.setState({
          sliderData,
          index: 0,
          images
        })
      }
    }

    calculateIndex(index) {
      const {sliderData} = this.state;
      const {countOfViewed} = this.props;

      const lastIndex = sliderData instanceof Array ?
        sliderData.length - 1 : sliderData.images.length - 1;

      if (index < 0) {
        return countOfViewed > 3 ? lastIndex + index + 1: lastIndex;
      } else if (index > lastIndex) {
        return countOfViewed > 3 ? 0 + index - lastIndex - 1 : 0;
      }
      return index;
    }

    updateSliderBackgrounds = index => {
      const {images} = this.state;
      const i = this.calculateIndex(index);

      if (images[i]) {
        return {
          backgroundImage: `url(${images[i]})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain'
        }
      }
    };

    updateSliderComponentData = index => {
      const {sliderData} = this.state;
      const i = this.calculateIndex(index);

      if (sliderData[i]) {
        return sliderData[i]
      }
    };

    handleArrowClick = event => {
      event.preventDefault();

      const {className} = event.target;
      const {index} = this.state;

      let newIndex = index;

      if (className.indexOf('arrow_right') > -1) {
        newIndex = this.calculateIndex(index + 1);
      } else if (className.indexOf('arrow_left') > -1) {
        newIndex = this.calculateIndex(index - 1);
      }

      this.setState(
        {
          index: newIndex
        })
    };

    render() {
      const {index, images} = this.state;
      const {countOfViewed} = this.props;

      const isViewedArrow = images.length > countOfViewed;

      return (
        <WrappedComponent {...this.props}
                          index={index}
                          images={images}
                          isViewedArrow={isViewedArrow}
                          handleArrowClick={this.handleArrowClick}
                          updateSliderComponentData={this.updateSliderComponentData}
                          updateSliderBackgrounds={this.updateSliderBackgrounds}/>
      )
    }
  }
};

export default withSlider
